import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { LocationService } from 'src/app/services/location/location.service';
import { LoginService } from 'src/app/services/login/login.service';
import { OrderService } from 'src/app/services/order/order.service';
import { ThumaMinaService } from 'src/app/services/thuma-mina/thuma-mina.service';
import { environment } from 'src/environments/environment';
import { LocationPage } from '../location/location.page';

@Component({
  selector: 'app-modal-pop',
  templateUrl: './modal-pop.page.html',
  styleUrls: ['./modal-pop.page.scss'],
})
export class ModalPopPage implements OnInit {
  @Input() docID: string;
  @Input() pickUpPointAddress: string;
  @Input() pointName: string;
  @Input() menuUrl: string;

  userID;

  requestForm: FormGroup;
  btnClicked = false;

  loading;

  startAddresses = [];
  endAddresses = [];
  startAddress;
  endAddress;
  selectedStartAddress;
  selectedEndAddress;

  continueRequest = false;

  FeesObject = {};
  deliveryFee;

  private mapKey = environment.mapKey;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private thumaMinaService: ThumaMinaService,
    private router: Router,
    private auth: AngularFireAuth,
    private loginService: LoginService,
    private httpClient: HttpClient,
    private loadingController: LoadingController,
    public locationService: LocationService,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    this.load();
    //
    this.locationService.address = '';
    this.locationService.coords.lat = 0;
    this.locationService.coords.lng = 0;
    //
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      setTimeout(() => {
        this.dismissLoad();
        if (user) {
          // console.log('user is logged in');
          this.getFees();
        } else {
          // console.log('user is not logged in');
          this.closeModal();
          this.router.navigate(['/home/login'], {
            queryParams: { destination: this.router.url },
          });
        }
      }, 3000);
    });

    if (this.pickUpPointAddress) {
      this.requestForm = this.formBuilder.group({
        region: ['', [Validators.required]],
        pickUpAddress: [
          { value: this.pickUpPointAddress, disabled: true },
          [Validators.required],
        ],
        dropPointAddress: ['', [Validators.required]],
        itemName: ['', [Validators.required]],
        description: ['', [Validators.required]],
      });
    } else {
      this.requestForm = this.formBuilder.group({
        region: ['', [Validators.required]],
        pickUpAddress: ['', [Validators.required]],
        dropPointAddress: ['', [Validators.required]],
        itemName: ['', [Validators.required]],
        description: ['', [Validators.required]],
      });
    }
  }

  getFees() {
    this.orderService
      .getDeliveryFees()
      .pipe(take(1))
      .subscribe((res) => {
        if (res.exists) {
          this.FeesObject = res.data() as Object;
        }
      });
  }

  onSelectChange(event) {
    const { fee, region } = event.detail.value;
    this.deliveryFee = fee;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  request() {
    const { pickUpAddress, dropPointAddress, itemName, description, region } =
      this.requestForm.getRawValue();

    if (this.locationService.address) {
      this.btnClicked = true;
      const dropOffCoords = this.locationService.coords;

      this.auth.authState.pipe(take(1)).subscribe((user) => {
        if (user) {
          const userID = user.uid;
          this.loginService
            .verifyID(userID)
            .pipe(take(1))
            .subscribe((res: any) => {
              if (res.exists) {
                const data = res.data();
                const role = data.role;
                if (role === 'User') {
                  if (!this.docID) {
                    this.docID = 'n/a';
                  }

                  if (!this.pointName) {
                    this.pointName = pickUpAddress;
                  }
                  const pointName = this.pointName;
                  let details = {
                    docID: this.docID,
                    pointName,
                    region,
                    pickUpAddress,
                    dropPointAddress,
                    itemName,
                    description,
                    dropOffCoords,
                    deliveryFee: this.deliveryFee,
                  };

                  // const pointName = this.pointName;
                  // let details = {
                  //   region,
                  //   pickUpAddress,
                  //   dropPointAddress,
                  //   itemName,
                  //   description,
                  //   dropOffCoords,
                  //   deliveryFee: this.deliveryFee,
                  // };

                  this.thumaMinaService.setDetails(details);
                  this.closeModal();
                  this.router.navigate(['/make-order'], {
                    queryParams: {
                      requestType: 'delivery-only',
                      requesterID: userID,
                    },
                  });
                } else {
                  this.btnClicked = false;
                  this.closeModal();
                  this.router.navigate(['/home/login']);
                }
              } else {
                this.btnClicked = false;
                this.closeModal();
                this.router.navigate(['/home/login']);
              }
            });
        } else {
          this.btnClicked = false;
          this.closeModal();
          this.router.navigate(['/home/login']);
        }
      });
    } else {
      this.openPointModal(dropPointAddress);
    }
  }

  openPointModal(address) {
    this.modalCtrl
      .create({
        component: LocationPage,
        componentProps: {
          searchAddress: address,
        },
      })
      .then((modalElement) => {
        modalElement.present();
      });
  }

  onChangeStart(event) {
    const queryAddress = event.detail.value;
    this.startAddress = queryAddress;
    if (queryAddress && queryAddress.length > 0) {
      if (queryAddress === this.selectedStartAddress) {
        this.startAddresses = [];
        this.startAddress = '';
      } else {
        this.searchStart(queryAddress);
      }
    } else {
      this.startAddresses = [];
    }
  }

  onChangeEnd(event) {
    const queryAddress = event.detail.value;
    this.endAddress = queryAddress;
    if (queryAddress && queryAddress.length > 0) {
      if (queryAddress === this.selectedEndAddress) {
        this.endAddresses = [];
        this.endAddress = '';
      } else {
        this.searchEnd(queryAddress);
      }
    } else {
      this.endAddresses = [];
    }
  }

  onSelectStart(addressItem) {
    this.selectedStartAddress = addressItem.address.label;
    this.requestForm.controls.pickUpAddress.setValue(this.selectedStartAddress);
    this.startAddresses = [];
    this.startAddress = '';
  }

  onSelectEnd(addressItem) {
    this.selectedEndAddress = addressItem.address.label;
    this.requestForm.controls.dropPointAddress.setValue(
      this.selectedEndAddress
    );
    this.startAddresses = [];
    this.startAddress = '';
  }

  startAddressSelect() {
    this.selectedStartAddress = this.startAddress;
    this.requestForm.controls.pickUpAddress.setValue(this.selectedStartAddress);

    this.startAddresses = [];
    this.startAddress = '';
  }

  endAddressSelect() {
    this.selectedEndAddress = this.endAddress;
    this.requestForm.controls.dropPointAddress.setValue(
      this.selectedEndAddress
    );

    this.endAddresses = [];
    this.endAddress = '';
  }

  searchStart(q) {
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    const address = q;
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.startAddresses = data.items;
      });
  }

  searchEnd(q) {
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    const address = q;
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.endAddresses = data.items;
      });
  }

  async load() {
    this.loading = await this.loadingController.create({
      message: 'loading....',
      spinner: 'crescent',
      showBackdrop: true,
    });

    this.loading.present();
  }

  dismissLoad() {
    this.loading.dismiss();
  }
}
